import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import type { AppEntry } from '@/apps/useApps';

/** Una app de tipo prototipo se muestra dentro del portal, no redirige fuera. */
export function isMockup(app: Pick<AppEntry, 'auth_mode'>): boolean {
  return app.auth_mode === 'mockup';
}

interface AppLinkProps {
  app: AppEntry;
  className?: string;
  children: ReactNode;
}

/**
 * Enlace a una app del catálogo. Para apps `mockup` navega internamente a la
 * vista de prototipo (`/preview/:slug`) vía React Router; para el resto usa el
 * endpoint de redirección del backend (`/api/apps/:slug/redirect`).
 */
export function AppLink({ app, className, children }: AppLinkProps) {
  if (isMockup(app)) {
    return (
      <Link to={`/preview/${app.slug}`} className={className}>
        {children}
      </Link>
    );
  }
  return (
    <a href={`/api/apps/${app.slug}/redirect`} className={className}>
      {children}
    </a>
  );
}
